module.exports = "<div class=dtRule__content> <span class=dtRule__label data-ng-bind=$ctrl.rule.title></span> </div> <div class=dtRule__info> <div class=dtRule__amount ng-if=$ctrl.rule.amount> <span ng-if=$ctrl.rule.amount.break data-ng-bind=$ctrl.rule.amount.break> </span>/<span ng-if=$ctrl.rule.amount.all data-ng-bind=$ctrl.rule.amount.all></span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/rule/rule.html
// module id = etko
// module chunks = 1